import * as React from "react";

function SvgWishpond(props, ref) {
  return (
    <svg
      id="Wishpond_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="15 0 220 220.4"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>
        {
          ".Wishpond_svg__st0{fill:#fff}.Wishpond_svg__st2{fill:#bfe1f6}.Wishpond_svg__st3{fill:#0b101a}"
        }
      </style>
      <path
        className="Wishpond_svg__st0"
        d="M145.6 48.3l-1.1-.2c-2.7-.5-5.5-1-8.5-1.2h-.7c.2-.7.4-1.5.5-2.3.2-1.3-.6-2.5-1.8-2.9-1.2-.4-2.5.1-3.2 1.2-.5.8-.9 1.6-1.4 2.2 0-.3 0-.5-.1-.8-.1-1.1-1-1.9-2-2.2-1-.3-2.2.2-2.9 1-1.9 2.5-2.7 3.4-4.7 3.7-.1 0-.2 0-.3.1-42.1 5-79 44.5-79 84.5 0 37.1 28.8 55.1 88.1 55.1s88.1-18 88.1-55.1c.1-37-31.7-74.3-71-83.1z"
      />
      <path
        className="Wishpond_svg__st0"
        d="M215 130.7c0 44.4-43.3 54.6-87.6 54.6S39.8 175 39.8 130.7s43.3-84.6 87.6-84.6S215 86.3 215 130.7z"
      />
      <path
        d="M215.7 127.8C209.3 75.7 168.4 57 168.4 57c2.4 5.1 4.4 10.1 6.1 14.9-2-1-4-.9-4-.9 1.4.5 3.5 2.4 4.9 3.8.1.2.1.4.2.6-1.6-.5-3.8-.3-3.8-.3 2.2.9 4 2.9 5.1 4.6 36.7 82.5-40 104.4-40 104.4 15 4.7 85.2-4.2 78.8-56.3z"
        opacity={0.05}
      />
      <path d="M191.4 72.4c11-3.1 23.2-11.1 6.7-24.3-16.3-13.1-23.3-3.3-23.3 10.7-8.5-5.6-17.8-9.8-27.6-12.3-.2 0-.3-.1-.5-.1-3.6-.9-7.2-1.6-10.9-2 1-5.9-1.1-10.9-1.2-11.3l-.1-.1c-.1-.2-.2-.4-.4-.5 0 0-.1 0-.1-.1-.2-.2-.3-.3-.6-.4h-.1c-.2-.1-.4-.1-.6-.1h-.4c-.1 0-.2.1-.3.1h-.2s-.1 0-.1.1c-.2.1-.3.2-.5.3l-.1.1c-.3.3-.5.8-.5 1.3-.1 2.3-.8 4.5-1.7 6.3-.3-1.5-.7-2.6-.8-2.9-.3-.8-1-1.3-1.9-1.3-.8 0-1.6.5-1.9 1.3-1.9 5.3-4.5 7-6.7 7.3-13.4 1.7-26.2 6.7-37.6 14.1 0-9.6-3.4-17.2-10.7-16.8h-.2c-.5 0-1.1.1-1.7.3-.2 0-.4.1-.6.1-.5.1-1 .3-1.5.5-.3.1-.7.3-1 .4-.3.1-.6.3-.9.4-.6.3-1.3.7-1.9 1 0 0-.1 0-.1.1-1.5.9-3 1.9-4.7 3.3-16.4 13.2-4.4 21.2 6.6 24.3-15.7 15.9-25.8 36.8-25.8 58.3 0 37.7 30.2 56.8 89.8 56.8s89.8-19.1 89.8-56.8c.1-21.3-10-42.2-25.7-58.1zm-64 110.8C69.9 183.2 42 166 42 130.7c0-39.7 36.3-77.2 77-81.9 3.3-.4 4.7-2.2 6.6-4.8.1 1.2.1 2.2-.2 3-.3 1.1-.9 2.2-.2 2.7.5.4 1.6.3 2.4-.4.2-.2 2.4-2.3 4.4-5.8-.1.8-.3 1.7-.6 2.5-.5 1.5-1.4 3.1-2.8 4.5-.8.8-.7 2.1.1 2.8.4.4.9.6 1.5.5.5 0 1-.2 1.4-.6 1.4-1.4 2.3-3 3.1-4.5 3.3.2 6.3.9 9.4 1.4 37.3 8.3 68.9 43.6 68.9 80.6-.1 35.3-28.1 52.5-85.6 52.5z" />
      <path d="M165.5 137.7s-22.4-7.9-27.7-39.2c-5.3-31.3 27.7-24 40.3-9.5 12.5 14.6 16.5 56.6-12.6 48.7z" />
      <ellipse
        transform="matrix(.9958 -.09106 .09106 .9958 -9.265 14.804)"
        className="Wishpond_svg__st2"
        cx={157.6}
        cy={108.9}
        rx={8.2}
        ry={9.2}
      />
      <circle className="Wishpond_svg__st3" cx={155.3} cy={110.4} r={5.6} />
      <circle className="Wishpond_svg__st0" cx={160} cy={106.7} r={2.3} />
      <g>
        <path d="M89.3 137.7s22.4-7.9 27.7-39.2-27.7-24-40.3-9.5-16.4 56.6 12.6 48.7z" />
        <ellipse
          transform="scale(.99995) rotate(-84.775 98.317 108.94)"
          className="Wishpond_svg__st2"
          cx={98.3}
          cy={108.9}
          rx={9.2}
          ry={8.2}
        />
        <circle className="Wishpond_svg__st3" cx={100.6} cy={110.4} r={5.6} />
        <circle className="Wishpond_svg__st0" cx={95.9} cy={106.7} r={2.3} />
      </g>
      <path className="Wishpond_svg__st0" d="M128.7 162.6v-15.4" />
      <g>
        <path
          className="Wishpond_svg__st0"
          d="M166.4 144.6s-.2-30.2-38.6-30.2-39.5 31.2-39.5 31.2 78.6-1 78.1-1z"
        />
        <path d="M150 134.6c-3.8-5.4-8.8-2-20.9-1.8h-.5c-12.2-.2-17.1-3.6-20.9 1.8-5.2 7.5 8.9 13.4 21 13.4H129c12.2-.1 26.2-5.9 21-13.4z" />
        <ellipse
          transform="rotate(-85.811 123.508 137.082) scale(.99997)"
          className="Wishpond_svg__st0"
          cx={123.5}
          cy={137.1}
          rx={2.1}
          ry={10.6}
        />
        <path d="M147.5 159.4c-.5-.3-1.1-.3-1.5.2 0 0-3.4 4.4-9.6 4.4-5.4 0-6.5-2.1-6.6-2.5v-14.4c0-.6-.5-1.1-1.1-1.1-.6 0-1.1.5-1.1 1.1v14.3c-.1.3-1.2 2.5-6.6 2.5-6.2 0-9.5-4.3-9.6-4.4-.4-.5-1-.6-1.5-.2-.5.4-.6 1-.2 1.5.2.2 4.1 5.3 11.4 5.3 4.4 0 6.6-1.3 7.7-2.5 1.1 1.2 3.3 2.5 7.7 2.5 7.3 0 11.2-5.1 11.4-5.3.2-.3.1-1-.4-1.4z" />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgWishpond);
